import {useMutation, gql} from '@apollo/client'
import {templateQueryResult} from './queryResults/templateQueryResult'

const useCreateTaskTemplateMutation = (onSuccess = () => {}) => {
    return useMutation(
        gql`
            mutation ($templateInput: CreateTemplateInput!) {
                createTaskTemplate (
                    templateInput: $templateInput
                )  {
                    ${templateQueryResult}
                }
            }
        `,
        {
            onCompleted: (res) => {
                onSuccess(res)
            }
        }
    )
}

export default useCreateTaskTemplateMutation